import moment from 'moment-timezone'

const TIME_ZONE = 'America/New_York'

export function getDayOfMonth(dateAndTime) {
	const date = moment(dateAndTime).tz(TIME_ZONE).format('D')

	return date
}

export function getDayOfWeek(dateAndTime) {
	const date = moment(dateAndTime).tz(TIME_ZONE).format('ddd')

	return date
}

export function getShortMonth(dateAndTime) {
	const date = moment(dateAndTime).tz(TIME_ZONE).format('MMM')

	return date
}

export function getDateString(dateAndTime) {
	const date = moment(dateAndTime).tz(TIME_ZONE).format('MMMM D')

	return date
}

export function getShortDateString(dateAndTime) {
	const date = moment(dateAndTime).tz(TIME_ZONE).format('MMM D')

	return date
}

export function getTimeString(dateAndTime) {
	const hour = moment(dateAndTime).tz(TIME_ZONE).format('hA')

	return `${hour} EST`
}

export function isInThePast(dateAndTime) {
	return moment().tz(TIME_ZONE).isAfter(moment(dateAndTime).tz(TIME_ZONE))
}

export function isTimeToMailEventPassed(eventDateAndTime, timeBefore, timeUnit, roundToMinutes) {
	if (!eventDateAndTime || !timeBefore) return false

	const minutes = moment().minutes()
	const roundedNow = moment().minutes(minutes - minutes % roundToMinutes).seconds(0).milliseconds(0)

	const mailingDateAndTime = moment(eventDateAndTime).subtract(timeBefore, timeUnit)

	return roundedNow.isSameOrAfter(mailingDateAndTime)
}

export function getFormat(dateAndTime) {
    const momentObject = moment(dateAndTime).tz(TIME_ZONE)

	const month = momentObject.format('MMMM')
	const day = momentObject.format('D')
	const hour = momentObject.format('hA')

	return { month, day, hour }
}